/**
 * Represents the type of a owner
 */
export enum UserTypeEnum {
  Patient = 'PATIENT',
  Hcp = 'HCP',
  Device = 'DEVICE',
  User = 'USER',
}
